export default "__VITE_ASSET__d84ea26f__"